<script setup lang="ts">
import { computed } from 'vue'
import { toneOf, TONE_CLASS, type Tone } from '~/utils/state'

const props = withDefaults(defineProps<{ status: string; tone?: Tone; size?: 6 | 7 | 8 }>(), { size: 6, tone: undefined })
const t = computed(() => TONE_CLASS[props.tone ?? toneOf(props.status)])
</script>

<template>
  <span
    class="shrink-0 rounded-full"
    :class="[t.dot, t.glow]"
    :style="{ width: size + 'px', height: size + 'px' }"
  />
</template>
